<mat-toolbar class="p-0 mat-elevation-z1">

  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center" style="background-color: #03a9f4">

    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">



      <div class="toolbar-separator" fxHide.gt-mat></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNav">
        <div class="logo ml-16">
          <span class="logo-icon">F</span>
        </div>
      </div>

      <div class="px-8 px-mat-16">
        <!-- <eguard-shortcuts></eguard-shortcuts> -->
      </div>

      <div class="title">
        <div fxFlex="" fxLayoutAlign="start center" style="margin:-10px;">
          <mat-icon class="logo-icon" *eguardIfOnDom>{{icon}}</mat-icon>&nbsp;&nbsp;
          <span class="logo-text h1">{{title}}</span>
        </div>
      </div>

    </div>
    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

      <!-- <mat-spinner *ngIf="showSpinner" class="loading-spinner mx-8"></mat-spinner> -->

      <div class="account-buttons">
        <button [routerLink]="['/settings']" class="user-button">
          <div fxLayout="row" fxLayoutAlign="center center">
            <img class="avatar" src="assets/images/avatars/profile.jpg">
            <span class="username mr-12" fxHide fxShow.gt-sm>{{user?.first_name}} {{user?.last_name}}</span>

          </div>
        </button>

      </div>
      <div class="toolbar-separator"></div>
      <!-- <button fxHide fxShow.gt-xs eguardToggleFullscreen (click)="fullScreen = !fullScreen" style="min-width: 56px;">
        <mat-icon matTooltip="Full Screen" *ngIf="!fullScreen">fullscreen</mat-icon>
        <mat-icon matTooltip="Exit Full Screen" *ngIf="fullScreen">fullscreen_exit</mat-icon>
      </button> -->
      <!--<eguard-search-bar (onInput)="search($event)"></eguard-search-bar>-->

      <div class="toolbar-separator"></div>

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>


    </div>
  </div>
</mat-toolbar>



// WEBPACK FOOTER //
// ./src/app/main/shared/components/toolbar/toolbar.component.html